import React, {createContext, useEffect, useState} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme';
import {v4 as uuid} from 'uuid';

// Import des pages
import Home from './pages/Home';
import SelectTickets from './pages/SelectTickets';
import Panier from './pages/Panier';
import StatusPaiement from './pages/StatusPaiement';
import MentionsLegales from './pages/MentionsLegales';
import Contact from './pages/Contact';
import Connexion from './pages/Connexion';
import TicketInfoForm from './pages/TicketsInfoForm';
import Compte from './pages/Compte';
import MesBillets from './pages/MesBillets';
import ResetPwd from './pages/ResetPwd';

// Import des polices Roboto
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

export const Context = createContext()

function App() {
  const [userId, setUserId] = useState(localStorage.getItem('user') || localStorage.getItem('anonUserId') || null);
  const [isConnected, setIsConnected] = useState(!!localStorage.getItem('token'));

  useEffect(() => { 

      if (!(!!userId)) {
        let userId = localStorage.getItem('anonUserId');
        if (!userId) {
          userId = uuid();
          localStorage.setItem('anonUserId', userId);
        }
        setUserId(userId);
      }
  }, []);

  return (
    <Context.Provider value={{ userId, setUserId, isConnected, setIsConnected}}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/billeterie" element={<Home />} />
          <Route path="/billetterie/:id" element={<SelectTickets />} />
          <Route path="/billetterie/:id/tickets-info" element={<TicketInfoForm />} />
          <Route path="/panier" element={<Panier />} />
          <Route path="/paiement/status" element={<StatusPaiement />} />
          <Route path="/paiement/status/:checkoutId" element={<StatusPaiement />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/connexion" element={<Connexion />} />
          <Route path='/reset-password/:token' element={<ResetPwd />} />
          {isConnected&&<Route path="/compte" element={<Compte />} />}
          {isConnected&&<Route path="/mes_billets" element={<MesBillets />} />}
          <Route path="*" element={<Home />} />
        </Routes>
      </Router>
    </ThemeProvider>
    </Context.Provider>
  );
}
export default App;